module.exports = {"450330100":"平乐镇","450330101":"二塘镇","450330102":"沙子镇","450330103":"同安镇","450330104":"张家镇","450330105":"源头镇","450330200":"阳安乡","450330201":"青龙乡","450330202":"桥亭乡","450330203":"大发瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450330.json
// module id = 1932
// module chunks = 0